document.addEventListener("DOMContentLoaded", function () {
  const truncated = document.getElementById("truncated");
  const fullDescription = document.getElementById("fullDescription");
  const readMoreBtn = document.querySelector(".read-more-collection");
  const readLessBtn = document.querySelector(".read-less-collection");

  // Check if all elements exist
  if (truncated && fullDescription && readMoreBtn && readLessBtn) {

    // Show full description and hide truncated
    readMoreBtn.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent scrolling to top
      truncated.style.display = "none";
      fullDescription.style.display = "block";
    });

    // Hide full description and show truncated
    readLessBtn.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent scrolling to top
      fullDescription.style.display = "none";
      truncated.style.display = "block";
    });
  }
});





  // Simple filter logic
  document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll("#page-software .sd-filter-btn");
    const cards = document.querySelectorAll("#software-cards .sd-card");

    buttons.forEach(btn => {
      btn.addEventListener("click", () => {
        buttons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        const filter = btn.getAttribute("data-software");
        cards.forEach(card => {
          card.style.display = (filter === "All" || card.getAttribute("data-software") === filter) ? "grid" : "none";
        });
      });
    });
  });


  


// Simple filter Document
document.addEventListener("DOMContentLoaded", function() {
  const searchInput = document.getElementById("sd-search");
  const fileTypeFilter = document.getElementById("sd-filetype");
  const seriesFilter = document.getElementById("sd-series");
  const productGroups = document.querySelectorAll("#sn-document .sd-product-group");

  function filterRows() {
    const searchText = searchInput.value.toLowerCase();
    const typeFilter = fileTypeFilter.value;
    const seriesValue = seriesFilter.value;

    productGroups.forEach(group => {
      const seriesMatch = !seriesValue || group.dataset.series === seriesValue;
      let anyRowVisible = false;

      const rows = group.querySelectorAll(".sd-row");
      rows.forEach(row => {
        const textMatch = row.innerText.toLowerCase().includes(searchText);
        const typeMatch = !typeFilter || row.dataset.type === typeFilter;
        const showRow = textMatch && typeMatch && seriesMatch;
        row.style.display = showRow ? "grid" : "none";
        if(showRow) anyRowVisible = true;
      });

      group.style.display = anyRowVisible ? "block" : "none";
    });
  }

  searchInput.addEventListener("input", filterRows);
  fileTypeFilter.addEventListener("change", filterRows);
  seriesFilter.addEventListener("change", filterRows);
});

